import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import Page from "../../../components/Page";
import BreadCrumbComponent from "../../../components/NewDesign/Misc/BreadCrumb/BreadCrumbComponent";
import CourseListLearnComp from "../../../components/b2cComponents/CourseListLearnComp";
import { clickStreamUser } from "../../../utils/AppUtils";
import { providerDetails, providerDetailsResClear } from "../../../redux/provider/actions";
import React, { useEffect, useState } from "react";
import VideoListingContentComponent from "../../../components/NewDesign/ListingContent/VideoListingContent/VideoListingContentComponent";
import CertificationListSection from "../../../components/Certification/CertificationListSection";
import EventListSection from "../../../components/NewDesign/Event/EventListSection";
import PartnerDetailSection from "../../../components/NewDesign/Partner/PartnerDetailSection";
import { SessionKeys } from "../../../utils/AppUtils";
import CoachingListSection from "../../../components/NewDesign/Coaching/CoachingListSection";
import VideoListingSectionComponent from "../../../components/NewDesign/ListingContent/VideoListingContent/VideoListingSectionComponent";
import { getActiveHeader, getNewContentCount } from "../../../redux/home/actions";
import CoachingListSectionParent from "../../../components/NewDesign/Coaching/CoachingListSectionParent";
import EventListSectionForPartner from "../../../components/NewDesign/Event/EventListSectionForPartner";
import LPListLearnComp from "../../../components/b2cComponents/LPListLearnComp";
import Loader from "../../../components/Loader/Loader";
import useLogin from "../../../custom-hooks/useLogin";

const PartnerDetailPage = (props) => {
  const [isOpenMenu, setIsOpenMenu] = useState(false);

  const toggleMenu = () => {
    setIsOpenMenu(!isOpenMenu);
  };
  const closeMenu = () => {
    setIsOpenMenu(false);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    dispatch(getActiveHeader("our-partners"));
  }, []);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const c = params.get("c");
  let decodedString = atob(c);
  let paramsReq = JSON.parse(decodedString);
  let providerId = "";
  let providerName = "";
  if (paramsReq) {
    providerId = paramsReq.provider_id;
    providerName = paramsReq.provider_name;
  }

  console.log("name--", providerName);
  let obj = {
    provider_id: providerId,
    provider_name: providerName,
  };

  let jsonString = JSON.stringify(obj);
  let encodedUrl = btoa(jsonString);

  // const providerId = paramsReq.provider_id;

  const [isLoading, setIsLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [partnerDetail, setPartnerDetail] = useState({});
  const [isFetching, setIsFetching] = useState(true);
  const authBroker = useSelector((state) => state.auth.authBroker);

  const { isLoggedIn } = useLogin();
  const count_response = useSelector((state) => state.home.newContentCount);
  useEffect(()=>{
    if(providerId){
    getNewCount();
    }
  },[providerId])
  const getNewCount = () => {
        dispatch(
          getNewContentCount({
            module: "newContentCount",
            postData: {
              token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
              provider_id: providerId
            },
          })
        );
      };
    
      const [newContentCount, setNewContentCount] = useState({
        courses: 0,
        videos: 0,
        service_count:0,
        lp_count:0,
        rp_count:0,
        combo_count:0
      });
    
      useEffect(() => {
        if (!_.isEmpty(count_response)) {
          if (count_response?.status === "success") {
            console.log("count---", count_response);
            setNewContentCount({
              courses: count_response?.payload?.payload?.course_count,
              videos: count_response?.payload?.payload?.video_count,
              service_count: count_response?.payload?.payload?.service_count,
              lp_count: count_response?.payload?.payload?.lp_count,
              rp_count: count_response?.payload?.payload?.rp_count,
              combo_count: count_response?.payload?.payload?.combo_count
            });
          }
        }
      }, [count_response]);

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      providerDetails({
        module: "providerDetails",
        postData: {
          provider_id: providerId,
          entity_type: "get_provider_details",
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        },
      })
    );

    return(()=>{
      dispatch(providerDetailsResClear());
    })
  }, []);

  const providersDetailsResponse = useSelector(
    (state) => state.provider.providerDetailsRes
  );

  const [breadCrumbData, setBreadCrumbData] = useState([
    // { name: "Learn", active: false, link: "", isLoading: false },
    { name: authBroker?.payload?.user?.config?.partner_menu_text !== undefined && !_.isEmpty(authBroker?.payload?.user?.config?.partner_menu_text)?
      authBroker?.payload?.user?.config?.partner_menu_text:
      "Learning Partners", active: false, link: "", isLoading: false },
    { name: "-", active: false, link: "", isLoading: true },
    { name: "-", active: false, link: "", isLoading: true },
  ]);

  const [routes, setRoutes] = useState([
    { value: "intro", label: "About" },
    { value: "courses", label: "Courses" },
    { value: "event", label: "Events" },
    { value: "certificate", label: "Certifications" },
    { value: "videos", label: "Videos" },
    { value: "coaching", label: "Services" },
  ]);

  const [menuList, setMenuList] = useState([]);

  useEffect(() => {
    const activeMenus = menuList.filter((menu) => menu.status === true);
    const transformedRoutes = activeMenus.map((menu) => ({
      value:
        menu.menu_value === "about"
          ? "intro"
          : menu.menu_value === "certificate"
          ? "certificate"
          : menu.menu_value === "event"
          ? "event"
          : menu.menu_value,
      label:
        menu.menu_name === "About"
          ? "About"
          : menu.menu_name === "Certificate"
          ? "Certifications"
          : menu.menu_name === "Event"
          ? "Events"
          : menu.menu_name === "learningpath"
          ? "Learning path"
          : menu.menu_name,
    }));
    console.log("transformed routes---", transformedRoutes);
    // Update routes state
    setRoutes(transformedRoutes);
  }, [menuList]);

  const routeTo = (type) => {
    let paramsReq = {
      provider_id: providerId,
      provider_name: providerName,
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    switch (type) {
      case "courses":
        clickStreamUser("clicked", { route: "courses" });
        navigate(`/partner-detail/courses/?tab=1&c=${encodedUrl}`);
        return;
      case "videos":
        clickStreamUser("clicked", { route: "videos" });
        navigate(`/partner-detail/videos/?c=${encodedUrl}`);
        return;
      case "event":
        clickStreamUser("clicked", { route: "event" });
        navigate(`/partner-detail/events?c=${encodedUrl}`);
        return;
      case "certificate":
        clickStreamUser("clicked", { route: "certificate" });
        navigate(`/partner-detail/certifications?c=${encodedUrl}`);
        return;
      case "coaching":
        clickStreamUser("clicked", { route: "coaching" });
        navigate(`/partner-detail/coaching/?c=${encodedUrl}`);
        return;
      case "learningpath":
        clickStreamUser("clicked", { route: "learningpath" });
        navigate(`/partner-detail/learningpath/?c=${encodedUrl}&tab=6`);
        return;
      default:
        clickStreamUser("clicked", { route: "courses" });
        navigate(`/partner-detail/?c=${encodedUrl}`);
        return;
    }
  };

  const renderMainContent = () => {
    if (props.type) {
      switch (props.type) {
        case "intro":
          return (
            <PartnerDetailSection
              partnerDetail={partnerDetail}
              isLoading={isLoading}
            />
          );
        case "courses":
          return <CourseListLearnComp />;
        case "videos":
          return <VideoListingSectionComponent />;
        case "event":
          return <EventListSectionForPartner />;
        case "certificate":
          return <CertificationListSection />;
        case "coaching":
          return <CoachingListSectionParent />;
        case "learningpath":
          return <LPListLearnComp />;
        default:
          return;
      }
    } else {
      return <></>;
    }
  };

  useEffect(() => {
    console.log("ppp-", providersDetailsResponse);
    if (
      !_.isEmpty(providersDetailsResponse) &&
      providersDetailsResponse?.status === "success"
    ) {
      setIsLoading(false);
      let providerList = providersDetailsResponse.payload.payload;
      if (!_.isEmpty(providerList)) {
        setPartnerDetail(providerList);
        setMenuList(providerList?.menu);
        setTitle(providerList.display_name);
        setIsFetching(false);
      }
    }
  }, [providersDetailsResponse]);

  useEffect(() => {
    if (!_.isEmpty(title)) {
      setBreadCrumbData([
        // {
        //   name: "Learn",
        //   active: false,
        //   link: "/learn/courses",
        //   isLoading: false,
        // },
        {
          name: authBroker?.payload?.user?.config?.partner_menu_text !== undefined && !_.isEmpty(authBroker?.payload?.user?.config?.partner_menu_text)?
      authBroker?.payload?.user?.config?.partner_menu_text:
      "Learning Partners",
          active: false,
          link: "/our-partners",
          isLoading: false,
        },
        {
          name: title,
          active: false,
          link: `/partner-detail?c=${encodedUrl}`,
          isLoading: false,
        },
        {
          name:
            props.type === "intro"
              ? "About"
              : props.type === "courses"
              ? "Courses"
              : props.type === "videos"
              ? "Videos"
              : props.type === "event"
              ? "Events"
              : props.type === "certificate"
              ? "Certifications"
              : props.type === "learningpath"
              ? "Learning path"
              : "Services",
          active: true,
          link: "",
          isLoading: false,
        },
      ]);
    } else {
      setTitle("");
    }
  }, [title, props]);
  return (
    <>
    <Loader start={isLoading} />
      <Page>
        <section class="bannersection">
          <div class="container">
            <div class="row justify-content-md-center">
              <div className="col col-lg-12">
                <BreadCrumbComponent crumbList={breadCrumbData} />
              </div>

              <div class="col-12 col-xl-2 leftmenusec">
                <div className="d-xl-none btn-filter-mob" onClick={toggleMenu}>
                  Menu
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      d="M0 17.875C0 17.3164 0.429688 16.8438 1.03125 16.8438H3.56641C3.99609 15.4688 5.32812 14.4375 6.875 14.4375C8.37891 14.4375 9.71094 15.4688 10.1406 16.8438H20.9688C21.5273 16.8438 22 17.3164 22 17.875C22 18.4766 21.5273 18.9062 20.9688 18.9062H10.1406C9.71094 20.3242 8.37891 21.3125 6.875 21.3125C5.32812 21.3125 3.99609 20.3242 3.56641 18.9062H1.03125C0.429688 18.9062 0 18.4766 0 17.875ZM8.25 17.875C8.25 17.1445 7.60547 16.5 6.875 16.5C6.10156 16.5 5.5 17.1445 5.5 17.875C5.5 18.6484 6.10156 19.25 6.875 19.25C7.60547 19.25 8.25 18.6484 8.25 17.875ZM15.125 7.5625C16.6289 7.5625 17.9609 8.59375 18.3906 9.96875H20.9688C21.5273 9.96875 22 10.4414 22 11C22 11.6016 21.5273 12.0312 20.9688 12.0312H18.3906C17.9609 13.4492 16.6289 14.4375 15.125 14.4375C13.5781 14.4375 12.2461 13.4492 11.8164 12.0312H1.03125C0.429688 12.0312 0 11.6016 0 11C0 10.4414 0.429688 9.96875 1.03125 9.96875H11.8164C12.2461 8.59375 13.5781 7.5625 15.125 7.5625ZM16.5 11C16.5 10.2695 15.8555 9.625 15.125 9.625C14.3516 9.625 13.75 10.2695 13.75 11C13.75 11.7734 14.3516 12.375 15.125 12.375C15.8555 12.375 16.5 11.7734 16.5 11ZM20.9688 3.09375C21.5273 3.09375 22 3.56641 22 4.125C22 4.72656 21.5273 5.15625 20.9688 5.15625H11.5156C11.0859 6.57422 9.75391 7.5625 8.25 7.5625C6.70312 7.5625 5.37109 6.57422 4.94141 5.15625H1.03125C0.429688 5.15625 0 4.72656 0 4.125C0 3.56641 0.429688 3.09375 1.03125 3.09375H4.94141C5.37109 1.71875 6.70312 0.6875 8.25 0.6875C9.75391 0.6875 11.0859 1.71875 11.5156 3.09375H20.9688ZM6.875 4.125C6.875 4.89844 7.47656 5.5 8.25 5.5C8.98047 5.5 9.625 4.89844 9.625 4.125C9.625 3.39453 8.98047 2.75 8.25 2.75C7.47656 2.75 6.875 3.39453 6.875 4.125Z"
                      fill="#2D2D2D"
                    />
                  </svg>
                </div>
                <ul className={`sidebar ${isOpenMenu ? "openMenu" : ""}`}>
                  <span
                    className="close-menu d-xl-none cursor-pointer"
                    onClick={toggleMenu}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M15.1484 13.5781C15.5703 14.0469 15.5703 14.75 15.1484 15.1719C14.6796 15.6406 13.9765 15.6406 13.5546 15.1719L8.02344 9.59375L2.44532 15.1719C1.97656 15.6406 1.27344 15.6406 0.851559 15.1719C0.382814 14.75 0.382814 14.0469 0.851559 13.5781L6.42969 8L0.851559 2.42188C0.382814 1.95312 0.382814 1.25 0.851559 0.828125C1.27344 0.359375 1.97656 0.359375 2.39844 0.828125L8.02344 6.45312L13.6015 0.875C14.0234 0.40625 14.7265 0.40625 15.1484 0.875C15.6172 1.29688 15.6172 2 15.1484 2.46875L9.57034 8L15.1484 13.5781Z"
                        fill="#2D2D2D"
                      />
                    </svg>
                  </span>
                  {routes.map((r, i) => {
                    return (
                      <li
                        className={`${
                          props.type === r.value ? "activemenu" : ""
                        }`}
                        onClick={closeMenu}
                      >
                        <button
                          className="reset-btn cursor-pointer"
                          onClick={() => routeTo(r.value)}
                        >
                          {r.label==="Coaching"?"Services":r.label}
                        </button>
                        { r.label === "Courses" ? (
                          newContentCount?.courses > 0 ? (
                            <span className="count">
                              {newContentCount?.courses}
                            </span>
                          ) : (
                            ""
                          )
                        ) : r.label === "Videos" ? (
                          newContentCount.videos > 0 ? (
                            <span className="count">
                              {newContentCount?.videos}
                            </span>
                          ) : (
                            ""
                          )
                        ) : r.label === "Coaching" ? (
                          newContentCount.service_count > 0 ? (
                            <span className="count">
                              {newContentCount?.service_count}
                            </span>
                          ) : (
                            ""
                          )
                        ) :r.label === "Learning Paths" ? (
                          newContentCount.lp_count > 0 ? (
                            <span className="count">
                              {newContentCount?.lp_count}
                            </span>
                          ) : (
                            ""
                          )
                        ) :r.label === "Role play" ? (
                          newContentCount.rp_count > 0 ? (
                            <span className="count">
                              {newContentCount?.rp_count}
                            </span>
                          ) : (
                            ""
                          )
                        ) :r.label === "Combo & Offers" ? (
                          newContentCount.combo_count > 0 ? (
                            <span className="count">
                              {newContentCount?.combo_count}
                            </span>
                          ) : (
                            ""
                          )
                        ) :(
                          ""
                        )}
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div class="col-12 col-xl-10">{!isLoading && renderMainContent()}</div>
            </div>
          </div>
        </section>
      </Page>
    </>
  );
};

export default PartnerDetailPage;
